import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import ReactTableColumnSwitcherHelper from '@Components/Results/services/react-table-columns-switcher-helper.service';
import { Button } from '@els/els-react--button';

import './sticky-table-header.scss';

function TableHeader({ getRef, headers, children, className, staticColumns, showHiddenColumns }) {
  return (
    <thead className={className} ref={getRef}>
      {children}
      <tr className="auto-resize">
        {headers.map((header) => (
          <th
            key={header.id}
            scope="col"
            colSpan={header.colspan ? header.colspan : 1}
            className={`column-${header.cssid} ${header.id === 'paureus' ? 'px-header' : ''} `}>
            {!staticColumns && (
              <Button type="link" size="small" className="show-more" aria-label="Show hidden columns" onClick={showHiddenColumns}>
                {ReactTableColumnSwitcherHelper.getHiddenColumnsAmount(headers)}...
              </Button>
            )}
            <InnerHTML tag="span" html={header.title} />
          </th>
        ))}
      </tr>
    </thead>
  );
}

TableHeader.propTypes = {
  className: PropTypes.string.isRequired,
  getRef: PropTypes.object,
  headers: PropTypes.array.isRequired,
  showHiddenColumns: PropTypes.func.isRequired,
};

TableHeader.defaultProps = {
  getRef: React.createRef(),
};

export default TableHeader;
